
import React, { useState, useEffect, useRef } from "react";
import styled from 'styled-components';

let autoComplete;

const InputElement = styled.input`
    outline: none;
    border: 1px solid #ccc;
    background-color: white;
    font: inherit;
    padding: 10px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    background: #F9FCFF;
    border: 1px solid #CBD5E0;
    border-radius: 0.25rem;
    color: #183D63;
    /* 16px keeps iOS from zooming on focus; :root only shrinks from 1200px. */
    font-size: 16px;
    line-height: 1.1rem;
    &:hover {
        border-color: #22B5F3;
    }
    &:focus {
        outline: none;
        border-color: #22B5F3;
    }
    @media (min-width: 1200px) {
        font-size: 0.9rem;
    }
`

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

function handleScriptLoad(updateQuery, autoCompleteRef, changeLocation) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ['geocode'] }
  );
  autoComplete.setFields(['address_component', 'geometry']);
  autoComplete.addListener("place_changed", () =>
    handlePlaceSelect(updateQuery, changeLocation, autoCompleteRef)
  );
}

async function handlePlaceSelect(updateQuery, changeLocation, autoCompleteRef) {
  const addressObject = autoComplete.getPlace();
  
  const location = {
    text: addressObject?.address_components?.[0]?.long_name +', '+ addressObject?.address_components?.[2]?.long_name,
    lat: addressObject?.geometry?.location.lat(),
    lng: addressObject?.geometry?.location.lng(),
  }
  
  if(location.lat) {
    const query = addressObject.formatted_address;
    updateQuery(query);
    changeLocation(location)
  }
  autoCompleteRef.current.value = null
}

function SearchLocationInput(props) {
  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyB1DEVrCX9FpA0SnoWFUIgyh1og2RF-8NI&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef, props.changeLocation)
    );
  }, []);

  return (
    <div className="search-location-input">
      <InputElement
        ref={autoCompleteRef}
        onChange={event => setQuery(event.target.value)}
        placeholder="Paris, france"
        // value={query}
      />
    </div>
  );
}

export default SearchLocationInput;